/**
 * Form Validation per Element
 */

const validateSearch = {
  required: 'A minimum of 3 characters is required',
  minLength: {
    value: 3,
    message: 'A minimum of 3 characters is required',
  },
  validate: (value: string) => value.trim().length >= 3 || 'A minimum of 3 characters is required',
};

/**
 * Namespaced Form Validation
 */

const validateForm = {
  search: validateSearch,
};

/**
 * Exports
 */

export default validateForm;

export { validateForm };
